<template>
  <v-btn
    icon="$mdiThemeLightDark"
    class="on-surface"
    size="small"
    density="comfortable"
    @click="toggleTheme"
  >
  </v-btn>
</template>

<script setup>
// Restore locale from state/localStorage, if it was set

import { useSiteStore } from "@/stores/site";
import { useTheme } from "vuetify";
import { computed, ref, onMounted } from "vue";

const theme = useTheme();
const siteStore = useSiteStore();

theme.global.name.value = siteStore.getThemeColor;

const toggleTheme = function () {
  let themePack =
    theme.global.name.value == "lsmLightTheme"
      ? "lsmDarkTheme"
      : "lsmLightTheme";
  theme.global.name.value = themePack;
  siteStore.setTheme(themePack);
};
</script>
